<template>
  <!-- 网络异常 -->
  <div class="shareCoupon-error">
      <div class="error-pic"><img src="//static.yunjiweidian.com/qnUpload/frontend/logo/icon_network_error.png"></div>
      <div class="error-txt">网络不太顺畅哦，请再次刷新或者检查网络</div>
      <div class="error-again" @click="goCoupon()">重新加载</div>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from "vue";

export default {
  name: "share-error",
  data() {
    return {
    };
  },
  activated() {
    
  },
  mounted() {
   
  },
  methods: {
    /**
     * 点击重新加载
     */
    goCoupon() {
      window.location.reload();
    }
   
  }
};
</script>

<style>
  /*网络异常*/
  .shareCoupon-error { width: 100%; height: 100%; background: #F1F5F8; text-align: center; position: fixed;}
  .shareCoupon-error .error-pic{ margin: 3.44rem auto 0 auto; }
  .shareCoupon-error .error-pic,.shareCoupon-error .error-pic img { width: 2rem; height: 2rem; }
  .shareCoupon-error .error-txt { margin: 0 auto; width: 3rem; font-size: .28rem; color: #9A9A9A; line-height: .4rem; font-weight: 700;}
  .shareCoupon-error .error-again{ margin: .28rem auto 0 auto; border:1px solid #9A9A9A; border-radius: .04rem; width: 1.56rem; height: .6rem; line-height: .6rem; text-align: center; font-size: .24rem; color: #666; font-weight: 700;}
</style>
